import {
  FETCH_REPORT_DATA,
  ReportsActionTypes,
  FETCH_REPORT_DATA_SUCCESS,
  FETCH_REPORT_DATA_ERROR,
  ReportPeriod,
} from 'types/actions/Exchanges/Reports.action';
import {
  IReportMonthly,
  IReportWeekly,
  IReportYearly,
} from '../../../types/models/Reports';

export interface ReportsState {
  data: {
    yearly: {
      [slug: string]: IReportYearly[];
    };
    monthly: {
      [slug: string]: IReportMonthly[];
    };
    weekly: {
      [slug: string]: IReportWeekly[];
    };
  };
  isLoading: boolean;
}

const initialExchanges: ReportsState = {
  data: {
    yearly: {},
    monthly: {},
    weekly: {},
  },
  isLoading: true,
};

export default (state = initialExchanges, action: ReportsActionTypes) => {
  switch (action.type) {
    case FETCH_REPORT_DATA:
      return {...state, isLoading: true};

    case FETCH_REPORT_DATA_SUCCESS: {
      const newState = {...state, isLoading: false};
      const {period, slug, data} = action.payload;
      switch (period) {
        case ReportPeriod.YEARLY:
          newState.data.yearly[slug] = data as IReportYearly[];
          break;
        case ReportPeriod.MONTHLY:
          newState.data.monthly[slug] = data as IReportMonthly[];
          break;
        case ReportPeriod.WEEKLY:
          newState.data.weekly[slug] = data as IReportWeekly[];
          break;
      }
      return newState;
    }

    case FETCH_REPORT_DATA_ERROR:
      return {...state, isLoading: false};

    default:
      return state;
  }
};
